module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-4.webp?0e75aa43";